<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model :model="platform" ref="platform" :rules="FormRules" :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">

        <a-form-model-item label="企业ID"   class="ant-form-item2 " >
          <a-input placeholder="" v-model="platform.cEntID" :disabled="true"/>
        </a-form-model-item>

        <a-form-model-item label="企业名称"   class="ant-form-item2 " >
          <a-input placeholder="" v-model="cEntName" :disabled="true"/>
        </a-form-model-item>

        <a-form-model-item label="所属项目"   class="ant-form-item2 "  prop="cSystemCode">
          <a-select
            placeholder=""
            v-model="platform.cSystemCode"
              @change="changePlat"  class="ant-form-item3"
          >
            <a-select-option v-for="item in PlatList" :key="item.cDicName"  :value="item.cDicCode">
              {{item.cDicCode}}
            </a-select-option>

          </a-select>
        </a-form-model-item>

        <a-form-model-item label="项目编码"  class="ant-form-item2 "  prop="cPlatformCode">
          <a-input v-model="platform.cPlatformCode" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="项目名称"   class="ant-form-item2 " prop="cPlatformName">
          <a-input v-model="platform.cPlatformName" placeholder="请输入" />
        </a-form-model-item>



        <a-form-model-item label="备注"  class="ant-form-item2 " >
          <a-textarea v-model="platform.Remark" placeholder="请输入备注"  />
        </a-form-model-item>


        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" @click="SaveForms" html-type="button">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>


    </a-card>
  </div>
</template>

<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData } from '@/common/request'
  export default {
    name: 'platformManagementForm',
    components: {
      TitleCard
    },
    data() {
      return {
        FormRules:{

          cPlatformCode:
            [
              { required: true, message: '请输入项目编码', trigger: 'blur' }
            ],
          cPlatformName: [
            { required: true, message: '请输入项目名称', trigger: 'blur' }
          ],


          cSystemCode:[
            { required: true, message: '请选择所属项目', trigger: 'change' }
          ]


        },
        titleMsg1: "设备管理",
        titleMsg2:'项目管理',
        titleMsg3:'项目管理',
        titleMsg4:'新增',
        cEntName:"",
        hascount:0,
        opencount:0,
        platform:{
          ID:"",
          cEntID:"",
          cSystemCode:"设施园艺",
          cPlatformCode:"",
          cPlatformName:"",
          iDelete:0,
          cCreateUserID:"",
          cCreateUserName:"",
          dCreateDate:"",
          cUpdateUserID:"",
          cUpdateUserName:"",
          dUpdateDate:"",
          Remark:""


        },
        checkList:[],
        PlatList:[],
        PList:[]
      }
    },
    mounted () {
      var that=this;

      if (that.$route.params.ID){
        that.platform.ID=that.$route.params.ID;
        that.HandleDetail();
      }
      that.platform.cEntID=that.$store.getters.User.enterprise.ID;
      that.cEntName=that.$store.getters.User.enterprise.cEntName;

      that.handlecount();
      that.getplatform();
    },

    methods:{
      async HandleDetail(){
    var that=this;

    let res = await that.$http.post('EntPlatformInfo/FindById/'+that.platform.ID,null)

    if(res.data.code=="200"){
      that.platform=res.data.obj.data;
    }
    else{


    }
  },    async handlecount(){
        let that=this;
        let param={cEntID:that.platform.cEntID,cSystemCode:'设施园艺'};
        let res= await that.$http.post('EntPlatformInfo/List ',param)

        if(res.data.code=="200"){
          if (res.data.obj.list){
            that.hascount= res.data.obj.list.length;

          }
        }
        else{
          that.$message.error(res.message)

        }

      },
      changePlat(record){
        this.opencount=record.iControlNum;


      },
       async getplatform(){
        let that=this;
        let param={dicClassCode: 'SystemCode'};
        let res=await that.$http.post('Dictionary/List',param)




        if(res.data){
          that.PList=res.data.obj.list;
          that.getplatset();



        }
        else{


        }
      },
      async getplatset(){
        let that=this;
        let param=null;
        let res=await that.$http.post('Enterprise/EntSysList/'+that.platform.cEntID,param)

        if(res.data){

          that.checkList=res.data.obj;

          if (that.checkList&&that.checkList.length>0){

            that.PList.forEach((ele,index)=>{



              let i=that.checkList.findIndex(x=>x.cSystemCode== ele.cDicCode);

              if (i>-1) {

                Object.assign(ele, { iControlNumValue: that.checkList[i].iControlNum })
                if (index == 0) {      }
                  that.opencount = that.checkList[i].iControlNum

                that.PlatList.push(ele)
              }


            })
          }
        }

      },
   async SaveForms(){

      var that=this;

     if (that.hascount+1>that.opencount&&!that.platform.ID){
       that.$message.error('已超过可添加数量!')
      return ;
     }
     let form=that.$refs['platform'];
     form.validate(async valid => {
       if (valid){
         let res = await that.$http.post('EntPlatformInfo/Save', that.platform)
         if (res.data.code == "200") {
           that.$message.success('保存成功!')
           that.$router.push({ path: '/platformManagement/platformManagement/platformManagementList' });
         } else {
           that.$message.error(res.data.message)

         }
       }

     });
  }
    }
  }
</script>


